export const REQUEST_MODEL_LIST = "request_model_list";
export const RECEIVE_MODEL_LIST = "receive_model_list";
export const MODEL_LIST_ERROR = "model_list_error";
export const SELECT_DISPLAYED_MODEL = "select_displayed_model";

export const REQUEST_DELETE_MODEL = "request_delete_model";
export const RECEIVE_DELETE_MODEL = "receive_delete_model";
export const DELETE_MODEL_ERROR = "delete_model_error";

import { getAllModels, deleteModel } from "src/actions/modelActions";

const getModelListRedux = () => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_MODEL_LIST,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_MODEL_LIST,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: MODEL_LIST_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const users = await getAllModels();
			return onSuccess(users);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

const deleteModelRedux = modelId => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_DELETE_MODEL,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_DELETE_MODEL,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: DELETE_MODEL_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			await deleteModel(modelId);
			return onSuccess(modelId);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};
export { getModelListRedux, deleteModelRedux };
